import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { useCheckAccess } from "../../utils/Utilities";
import { sendBulkMobileStatusUpdate } from "../../service/ContactApi";

function BulkMobileStatusUpdate() {
  useCheckAccess("ContactAdmin");

  const [loading, setLoading] = useState(false);
  const [batchResults, setBatchResults] = useState([]);
  const [error, setError] = useState(null);
  const [collection, setCollection] = useState("test_family_members");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [inputData, setInputData] = useState("");

  const handleConfirmSend = async () => {
    setShowConfirmModal(false);
    const lines = parseLines(inputData);
    await proceedWithUpdate(lines);
  };

  const parseLines = (input) => {
    return input
      .trim()
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
  };

  const startBulkStatusUpdate = async () => {
    if (!inputData.trim()) {
      setError("தயவு செய்து எண்கள் மற்றும் நிலைகளை உள்ளிடுங்கள்.");
      return;
    }

    const lines = parseLines(inputData);

    const invalidLines = lines.filter((line) => {
      const [mobile] = line.split("-");
      return !/^\d{10}$/.test(mobile);
//      return !/^\d{10}$/.test(mobile) || !["DND", "DEL"].includes(status);

    });

    if (invalidLines.length > 0) {
      setError(`தவறான வரிகள் உள்ளன:\n${invalidLines.join("\n")}`);
      return;
    }

    if (collection === "family_members") {
      setShowConfirmModal(true);
    } else {
      await proceedWithUpdate(lines);
    }
  };

  const proceedWithUpdate = async (lines) => {
    setLoading(true);
    setBatchResults([]);
    setError(null);

    try {
      const response = await sendBulkMobileStatusUpdate({ collection, lines });

      if (!response.ok) {
        throw new Error("பின் நிரலாக்க பிழை. மீண்டும் முயற்சிக்கவும்.");
      }

      const data = await response.json();

      setBatchResults([
        {
          batch: "All",
          successCount: data.successCount,
          failedCount: data.failedCount,
          message: data.message,
        },
      ]);
    } catch (err) {
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>Bulk Mobile Status Update</title>
        <link rel="canonical" href="/sms/bulk-mobile-status-update" />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs />
            <br />
            <h3>மொபைல் SMS நிலை பெருமளவில் புதுப்பி</h3>
            <br />

            {/* Collection Selector */}
            <div className="detail-item">
              <label htmlFor="collection">அகராதி தொகுப்பு (Collection): </label>
              <select
                id="collection"
                value={collection}
                onChange={(e) => setCollection(e.target.value)}
                className="auth_input"
              >
                <option value="">-- Collection ஒன்றை தேர்ந்தெடுக்கவும் --</option>
                <option value="test_family_members">test_family_members</option>
                <option value="family_members">family_members</option>
              </select>

              {collection === "family_members" && (
                <div style={{ color: "red", marginTop: "10px", fontWeight: "bold" }}>
                  ⚠️ இது உண்மையான பயனர்கள் தொகுப்பு.
                </div>
              )}
            </div>

            {/* Input Area */}
            <div className="detail-item">
              <label htmlFor="inputData">
                மொபைல்-ஸ்டேட்டஸ் பட்டியல் (e.g., 1234567890-DND):
              </label>
              <textarea
                id="inputData"
                rows={10}
                className="auth_input"
                placeholder={
                  "ஒவ்வொரு வரியிலும் ஒரு எண்ணை கொடுங்கள்:\n1234567890-DND\n1234567891-DEL"
                }
                value={inputData}
                onChange={(e) => setInputData(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <button
              type="button"
              className="auth_submit"
              disabled={loading}
              onClick={startBulkStatusUpdate}
            >
              {loading ? "பதிவேற்றுகிறது..." : "மொபைல் நிலையை புதுப்பி"}
            </button>

            <br />
            <br />

            {/* Error */}
            {error && (
              <div className="auth_error" style={{ whiteSpace: "pre-wrap" }}>
                ❗ {error}
              </div>
            )}

            {/* Results */}
            {batchResults.length > 0 && (
              <div>
                <h4>பதில்கள்:</h4>
                <table
                  className="detail-table"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      <th>பேச்சு எண்</th>
                      <th>வெற்றி</th>
                      <th>தோல்வி</th>
                      <th>செய்தி</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchResults.map((batch, idx) => (
                      <tr key={idx}>
                        <td>{batch.batch}</td>
                        <td>{batch.successCount}</td>
                        <td>{batch.failedCount}</td>
                        <td>{batch.message || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h3>உறுதிப்படுத்தல் தேவை</h3>
            <p>
              இது <strong>உண்மையான பயனர்கள்</strong> ஆகும்.<br />
              தொடர விரும்புகிறீர்களா?
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                onClick={handleConfirmSend}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  marginRight: "10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                ஆம், அனுப்பு
              </button>
              <button
                onClick={() => setShowConfirmModal(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ccc",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                இல்லை, ரத்து செய்
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BulkMobileStatusUpdate;
